module.exports = __webpack_public_path__ + "img/people.81191a18.svg";